"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _createSharedReactContext = _interopRequireDefault(require("create-shared-react-context"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ReactlyticsContext = (0, _createSharedReactContext.default)({
  track: function track() {
    // eslint-disable-next-line no-console
    console.warn('Failed to get Reactlytics context due to not finding a ReactlyticsProvider');
    return null;
  }
}, 'reactlytics');
var _default = ReactlyticsContext;
exports.default = _default;